import axios from "axios";


export const fetchProductsPaginate = (category, page, sortField, sortType) => {
    return async dispatch => {
        try {
            dispatch({type: 'FETCH_PRODUCTS'});
            const response = await axios.get(`https://holz-city.ru:444/product?category=${category}&page=${page}&sortField=${sortField}&sortType=${sortType}`);
            dispatch({type: 'FETCH_PRODUCTS_SUCCESS', payload: response.data.data});
            dispatch({type: 'FETCH_COUNT_PAGE_SUCCESS', payload: response.data});
        } catch (e) {
            dispatch({
                type: 'FETCH_PRODUCTS_ERROR',
                payload: 'Произошла ошибка при загрузки'
            });
        }
    }
}

export const fetchSimilar = (category, withoutId) => {
    return async dispatch => {
        try {
            dispatch({type: 'FETCH_SIMILAR_PRODUCTS'});
            const response = await axios.get(`https://holz-city.ru:444/product?category=${category}&withoutId=${withoutId}`);
            dispatch({type: 'FETCH_SIMILAR_PRODUCTS_SUCCESS', payload: response.data.data});
        } catch (e) {
            dispatch({
                type: 'FETCH_SIMILAR_PRODUCTS_ERROR',
                payload: 'Произошла ошибка при загрузки'
            });
        }
    }
}


export const fetchProductDetail = (id) => {
    return async dispatch => {
        try {
            dispatch({type: 'FETCH_PRODUCT_DETAILS'});
            const response = await axios.get(`https://holz-city.ru:444/product/${id}`);
            dispatch({type: 'FETCH_PRODUCT_DETAILS_SUCCESS', payload: response.data});
        } catch (e) {
            dispatch({type: 'FETCH_PRODUCT_DETAILS_ERROR', payload: 'Произошла ошибка при загрузки'});
        }
    }
}

export const fetchProductInMainPage = async () => {
    const categories = [2, 3, 4, 6];

    const responses = await Promise.all(
        categories.map(category => axios.get(`https://holz-city.ru:444/product?category=${category}`))
    );

    return responses.map(response => response.data.data);
}